import React from "react";
import styled from "styled-components";
import menu from "../assets/rainbowl-menu.pdf";

const PDFViewer = () => {
 return (
 <Section>
    <iframe src={menu} width='100%' height="100%" />
 </Section>
 );
};

const Section = styled.section`
  padding-top: 80px;
  height: 100vh;
  width: 100%;
`;

export default PDFViewer;